import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'components/core/Link';
import './SizeChip.scss';

const SizeChip = ({ label, url, isActive }) => (
	<Link
		to={url}
		className={classnames('size-chip', {
			'size-chip--active': isActive,
		})}
	>
		{label}
	</Link>
);

SizeChip.propTypes = {
	label: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired,
	isActive: PropTypes.bool,
};

SizeChip.defaultProps = {
	isActive: false,
};

export default SizeChip;
